export default __webpack_public_path__ + "static/media/572.93064db2.png";